module.exports = __webpack_public_path__ + "static/media/3022.c7c7bb74.jpg";